<template>
  <fullscreen-dialog
    v-model="model"
    :title="`${toLatin(company?.name || '')} ${$t('additional_meal').toLowerCase()}`"
    :subtitle="localeDate(selectedDate)"
    color="primary"
    hide-padding
    :save-text="$t('save')"
    @save="close"
    hide-footer
    fluid-container
  >
    <template #filters>
      <page-toolbar
        v-model="addedMealsSearch"
        searchable
        :search-placeholder="$t('search')"
      >
        <template #filters>
          <v-col cols="4">
            <date-picker
              v-model="selectedDate"
              color="white"
              :label="$t('date')"
              single-date
              showDay
            />
          </v-col>
        </template>
      </page-toolbar>
    </template>
    <v-alert type="info" text dense border="left" class="ma-0" color="info" dismissible>
      <div class="d-flex align-center">
        <div class="flex-grow-1">
          <div class="text-body-2 font-weight-medium mb-1">
            {{ $t("additional_meals_for_employees") }}.
            {{ $t("select_shift_and_adjust_quantities") }}
          </div>
        </div>
      </div>
    </v-alert>

    <additional-meals-for-group-companies
      v-if="company?.type === 'group'"
      :company="company"
      :selected-date="selectedDate"
    />
    <additional-meals-shift-tabs
      v-else
      ref="shiftTabs"
      :company="company"
      :selected-date="selectedDate"
      :search="addedMealsSearch"
      @save="onMealSaved"
    />
  </fullscreen-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import FullscreenDialog from "@/components/dialogs/FullscreenDialog.vue";
import PageToolbar from "@/components/global/PageToolbar.vue";
import AdditionalMealsShiftTabs from "./AdditionalMealsShiftTabs.vue";
import AdditionalMealsForGroupCompanies from "@/components/categoryMenuGroup/AdditionalMealsForGroupCompanies.vue";

export default {
  name: "ReportMealsPackagesAddMeal",
  components: {
    FullscreenDialog,
    PageToolbar,
    AdditionalMealsShiftTabs,
    AdditionalMealsForGroupCompanies,
  },
  mixins: [hasModel],
  props: {
    company: {
      type: Object,
      required: true,
    },
    date: {
      type: String,
      default: () => new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    },
  },
  data() {
    return {
      addedMealsSearch: "",
      selectedDate: this.date || new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10),
    };
  },

  methods: {
    onMealSaved() {
      this.$emit("refreshMeal");
    },

    close() {
      this.model = false;
    },
  },
  watch: {
    async model(newVal) {
      if (newVal) {
        // Reset date to prop value when opening dialog
        this.selectedDate = this.date || new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().substr(0, 10);
        await this.$nextTick();
      } else {
        this.addedMealsSearch = "";
        if (this.$refs.shiftTabs) {
          this.$refs.shiftTabs.resetData();
        }
      }
    },

    date: {
      handler(newVal) {
        if (newVal && this.selectedDate !== newVal) {
          this.selectedDate = newVal;
        }
      },
      immediate: true,
    },
  },
};
</script>
